<template>
	<div class="z-backStage">
		<backMenu></backMenu>
		<div class="main">
			<div class="head">
				<router-link tag="div" :to="{name:'dashboard'}">
					<img src="~assets/image/back-to-front.png">
					<span>进入前台</span>
				</router-link>
			</div>
			<div class="router" :class="{side:$route.name!='backhome'}">
				<transition name="backpage">
					<router-view></router-view>
				</transition>
				<transition name='backpage'>
					<home v-show="$route.name=='backhome'"></home>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
	import backMenu from 'src/views/backEndStage/other/backMenu.vue'
	import home from './home.vue'
	
    export default {
		components:{
			backMenu,home,
		},
		created(){
			this.$func.getCurrencyList(true);   //获取快币列表
		},
    }
</script>

<style lang="less">
	@import "~src/assets/less/backless/index.less";
	 ::-webkit-input-placeholder {
		color: #97a8be;
	}

	:-moz-placeholder {
		color: #97a8be;
	}

	::-moz-placeholder {
		color: #97a8be;
	}

	:-ms-input-placeholder {
		color: #97a8be;
	}
</style>







// WEBPACK FOOTER //
// page-endhome.vue?1f7f11c5